import { createFileRoute } from "@tanstack/react-router";
import { ParentAssessment } from "@/lib/lazyPages";
// Metadata-only mirror: importing the full assessment definitions here put all
// of their questions and copy into the shared entry chunk (route heads are
// critical code), which every visitor had to download and parse.
import { PARENT_ASSESSMENT_META } from "@/data/parentAssessmentMeta";
import { seoHead } from "@/lib/seo/head";
import { RelatedResources } from "@/components/seo/RelatedResources";
import { TOPIC_BY_SLUG } from "@/content/topics";

export const Route = createFileRoute("/assessments/$slug")({
  head: ({ params }) => {
    const config = Object.values(PARENT_ASSESSMENT_META).find((c) => c.slug === params.slug);
    if (!config) return seoHead({ title: "Assessment not found", noindex: true });

    // seoHead appends " | LeadXkids" (12 chars), so the base has 48 to play
    // with before Google truncates: only add the suffix when it still fits.
    const base = config.title.replace(/\?$/, "");
    return seoHead({
      title: base.length <= 33 ? `${base} · Parent check` : base,
      description: config.blurb,
      canonical: `/assessments/${config.slug}`,
    });

  },
  component: AssessmentRoute,
});

/** Topic hubs genuinely related to each assessment (resolved against real topics). */
const ASSESSMENT_TOPICS: Record<string, string[]> = {
  communication: ["communication"],
  "dealing-with-failure": ["resilience"],
  "growth-mindset": ["growth-mindset"],
  "empathy-kindness": ["friendships", "communication"],
  "vuca-readiness": ["resilience", "growth-mindset"],
};

function AssessmentRoute() {
  const { slug } = Route.useParams();
  const topics = (ASSESSMENT_TOPICS[slug] ?? []).map((s) => TOPIC_BY_SLUG[s]).filter(Boolean);
  return (
    <>
      <ParentAssessment />
      {topics.length > 0 && (
        <RelatedResources
          title="Related parent resources"
          items={[
            ...topics.map((t) => ({ href: `/topics/${t.slug}`, label: t.title, note: t.description })),
            { href: "/assessments", label: "All five parent assessments", note: "Short behavioural checks answered by parents." },
          ]}
        />
      )}
    </>
  );
}
